import { jsx as _jsx } from "react/jsx-runtime";
import { GenericDropDownV3 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_Environment } from './ModuleFE_Environment.js';
const Props_DropDown = {
    module: ModuleFE_Environment,
    modules: [ModuleFE_Environment],
    mapper: item => [item.label],
    placeholder: 'Choose an environment',
    renderer: item => _jsx("div", { className: "ll_h_c", children: item.label })
};
export const DropDown_Environment = GenericDropDownV3.prepare(Props_DropDown);
//# sourceMappingURL=ui-components.js.map